<template>
  <section class="livratos-double-section">
    <div class="container">
      <div class="livratos-row">
        <div class="livratos-col">
          <div class="livratos-image-card">
            <img
              src="@/assets/pictures/vehicule-mockup.webp"
              alt="Interface principale Livratos avec tableau de bord et choix du véhicule"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="livratos-col">
          <div class="livratos-text-card">
            <p class="badge">Interface web & mobile</p>
            <h2>
              Votre cockpit de livraisons,<br />
              du tableau de bord au véhicule
            </h2>
            <p>
              L’interface principale de Livratos a été pensée comme un vrai
              tableau de bord : à gauche, un menu clair pour filtrer vos courses
              (en attente, en transit, <strong>livrées</strong>, interrompues),
              accéder à la création de <strong>livraisons</strong> express ou
              programmées, à votre planning et à votre profil. Au centre, une
              vue structurée de vos courses pour garder le contrôle en un coup
              d’œil.
            </p>
            <ul class="features-list">
              <li>
                Filtres rapides sur les courses : en attente, en transit,
                <strong>livrées</strong> ou interrompues
              </li>
              <li>
                Création guidée de <strong>livraisons</strong> express ou
                programmées depuis la même interface
              </li>
              <li>
                Flotte complète disponible : moto, utilitaire léger, fourgon,
                grand fourgon, plateau ou poids lourd selon la nature de la
                <strong>livraison</strong>.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="livratos-row reverse">
        <div class="livratos-col">
          <div class="livratos-image-card">
            <img
              src="@/assets/pictures/chargement-mockup.webp"
              alt="Pré-sélection des objets et visualisation 3D dans le coffre du véhicule"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="livratos-col">
          <div class="livratos-text-card">
            <p class="badge">Préparation de chargement 3D</p>
            <h2>
              Choisissez vos objets,<br />
              la 3D s’occupe du volume
            </h2>
            <p>
              Lors de la création d’une <strong>livraison</strong>, Livratos
              vous permet de présélectionner les objets à charger : colis
              (cartons), palettes, sacs, barres… avec des tailles prédéfinies ou
              des dimensions personnalisées. Chaque objet est modélisé en 3D et
              placé dans un conteneur représentant le coffre du véhicule choisi
              pour que vous visualisiez immédiatement l’encombrement réel.
            </p>
            <ul class="features-list">
              <li>
                Objets prédéfinis prêts à l’emploi + création d’objets sur
                mesure pour coller exactement à votre réalité terrain.
              </li>
              <li>
                La 3D vous montre en un clin d’œil ce qui rentre, ce qui reste
                et comment
                <strong>optimiser l’espace dans votre véhicule</strong>.
              </li>
              <li>
                <strong>Optimisation automatique du chargement</strong> :
                orientation intelligente des objets, recommandation du véhicule
                idéal et gestion des règles d’empilement.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LivratosDoubleSection",
};
</script>

<style lang="scss" scoped>
.livratos-double-section {
  background-color: $background;
  padding: 80px 20px;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 60px;

    @media (min-width: 992px) {
      gap: 80px;
    }
  }

  .livratos-row {
    display: flex;
    flex-direction: column;
    gap: 24px;

    @media (min-width: 992px) {
      flex-direction: row;
      gap: 32px;
      align-items: stretch; // 👉 mêmes hauteurs
    }

    &.reverse {
      @media (min-width: 992px) {
        flex-direction: row-reverse;
      }
    }

    .livratos-col {
      flex: 1;
      display: flex;
      align-items: stretch;
    }

    .livratos-image-card {
      background-color: $color-primary;
      border-radius: 16px;
      padding: 3px;
      width: 100%;
      box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18),
        0 6px 16px rgba(0, 0, 0, 0.12);

      display: flex;
      align-items: center;
      justify-content: center;

      @media (min-width: 992px) {
        padding: 22px;
      }

      img {
        width: 100%;
        border-radius: 12px;
        object-fit: cover;
        display: block;
      }
    }

    .livratos-text-card {
      background-color: #000;
      border-radius: 16px;
      padding: 22px 22px 24px;
      width: 100%;
      color: #fff;
      box-shadow: 0 20px 45px rgba(0, 0, 0, 0.28), 0 8px 20px rgba(0, 0, 0, 0.2);

      @media (min-width: 768px) {
        padding: 26px 28px 30px;
      }

      .badge {
        display: inline-block;
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        padding: 0.25rem 0.8rem;
        border-radius: 999px;
        background: rgba($color-primary, 0.18);
        color: $color-primary;
        font-weight: 600;
        margin-bottom: 0.85rem;
      }

      h2 {
        font-size: 1.6rem;
        font-weight: 700;
        color: #ffffff;

        @media (min-width: 768px) {
          font-size: 2.1rem;
        }
      }

      p {
        margin-top: 1rem;
        font-size: 0.98rem;
        color: rgba(255, 255, 255, 0.85);

        @media (min-width: 768px) {
          font-size: 1.05rem;
        }
      }

      .features-list {
        margin-top: 1.1rem;
        padding-left: 0;
        list-style: none;

        li {
          position: relative;
          padding-left: 1.2rem;
          margin-bottom: 0.4rem;
          font-size: 0.95rem;
          color: rgba(255, 255, 255, 0.85);
          &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0.55em;
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background-color: $color-primary;
            transform: translateY(-50%);
            box-shadow: 0 0 0 2px rgba($color-primary, 0.25);
          }
        }
      }
    }
  }
}
</style>
